class StyleProperties {
    root = document.documentElement;
    resizeDebounce;
    refreshRate = 25;

    constructor() {
        document.addEventListener("DOMContentLoaded", () => {
            this.setClientDimensions();
            requestAnimationFrame(this.init.bind(this));
        });
    }

    init() {
        this.setClientDimensions();
        setTimeout(() => requestAnimationFrame(this.init.bind(this)), 1000 / this.refreshRate);
    }

    setProperty(name: string, value: string) {       
        this.root.style.setProperty(name, value);
    }

    setClientDimensions() {
        this.setProperty("--client-width", document.body.clientWidth + "px");
        this.setProperty("--client-height", document.body.clientHeight + "px");
    }
}

export default new StyleProperties();